import { render, staticRenderFns } from "./NowhowDismissableTextbox.vue?vue&type=template&id=5f4b33de"
import script from "./NowhowDismissableTextbox.vue?vue&type=script&lang=ts"
export * from "./NowhowDismissableTextbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports